// extracted by mini-css-extract-plugin
export var fadeIn = "_23-0";